import React from "react";
import "./header.scss";
import logoImg from "../../assets/images/logo.png";
import thanksImg from "../../assets/images/thanks.png";

const Header = () => {
  return (
    <header className="header">
      <img
        className="header__logo"
        src={logoImg}
        alt="West Virginia courtesy patrol logo"
        width="100px"
        height="100px"
      />

      <img
        className="header__thank-you-img"
        src={thanksImg}
        alt="Thank you driver"
        width="320px"
        height="70px"
      />

      <h1 className="header__title">
        West Virginia Courtesy Patrol comment form
      </h1>

      <h1 className="header__subtitle">
        We value feedback on the service we provide for the motorists of West
        Virginia. Please fill out the form below with as much detail as
        possible!
      </h1>
    </header>
  );
};

export default Header;
